import moment from 'moment';
import { ACESSOS_NSMP, EQUIPES_NSMP, rotuloNsmp } from '../../../../../constants/nsmpUtils';

const rotuloAcesso = (valor) => rotuloNsmp(ACESSOS_NSMP, valor);
const rotuloEquipe = (valor) => rotuloNsmp(EQUIPES_NSMP, valor);

const texto = (valor) => (valor == null ? '' : String(valor).trim());

const simNao = (valor) => {
  if (valor === true || valor === 'true') return 'Sim';
  if (valor === false || valor === 'false') return 'Não';
  return '';
};

const dataHora = (valor) => (valor ? moment(valor).format('DD/MM/YYYY HH:mm') : '');

/** Campos que o inspetor preencheu, agrupados pelo uso que o digitador faz deles. */
export const montarGrupos = (values) => [
  {
    titulo: 'Atendimento',
    campos: [
      { nome: 'Prioridade', valor: texto(values.prioridade) },
      { nome: 'Acesso', valor: rotuloAcesso(values.acesso) || texto(values.acesso) },
      { nome: 'Acesso veículo', valor: simNao(values.acessoVeiculo) },
      { nome: 'Equipe indicada', valor: rotuloEquipe(values.equipeIndicada) || texto(values.equipeIndicada) },
    ],
  },
  {
    titulo: 'Endereço',
    campos: [{ nome: 'Endereço', valor: texto(values.endereco), span: 4 }],
  },
  {
    titulo: 'Poste',
    campos: [
      { nome: 'Número do poste', valor: texto(values.numeroPoste) },
      { nome: 'Altura', valor: texto(values.alturaPoste) },
      { nome: 'Capacidade', valor: texto(values.capacidadePoste) },
      { nome: 'Tipo', valor: texto(values.tipoPoste) },
    ],
  },
  {
    titulo: 'Estruturas e cabos',
    campos: [
      { nome: 'Estrutura BT', valor: texto(values.estruturaBt) },
      { nome: 'Cabo BT', valor: texto(values.caboBt) },
      { nome: 'Estrutura MT', valor: texto(values.estruturaMt) },
      { nome: 'Cabo MT', valor: texto(values.caboMt) },
    ],
  },
  {
    titulo: 'Observação do inspetor',
    campos: [{ nome: 'Observação', valor: texto(values.observacao), span: 4, multilinha: true }],
  },
  {
    titulo: 'Registro',
    campos: [
      { nome: 'Código', valor: texto(values.codigo) },
      { nome: 'Foto drone', valor: dataHora(values.dataFotoDrone) },
      { nome: 'Foto drone fim', valor: dataHora(values.dataFotoDroneFim) },
    ],
  },
];

/** Resumo de uma linha para o cabeçalho da seção (visível mesmo recolhida). */
export const montarResumo = (values) => [
  { nome: 'Prioridade', valor: texto(values.prioridade) },
  { nome: 'Acesso', valor: rotuloAcesso(values.acesso) || texto(values.acesso) },
  { nome: 'Veículo', valor: simNao(values.acessoVeiculo) },
  { nome: 'Equipe', valor: rotuloEquipe(values.equipeIndicada) || texto(values.equipeIndicada) },
  { nome: 'Endereço', valor: texto(values.endereco) },
].filter((item) => item.valor);
